import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
/**
 * The purpose of this class is to emulate the behavior of the PhotoSwipeLightbox
 * to provide the ability to use plugins
 */
var PhotoSwipeLightboxStub = /*#__PURE__*/_createClass(function PhotoSwipeLightboxStub(pswp) {
  _classCallCheck(this, PhotoSwipeLightboxStub);
  this.pswp = pswp;
  this.on = pswp.on.bind(pswp);
  this.off = pswp.off.bind(pswp);
  this.dispatch = pswp.dispatch.bind(pswp);
});
export { PhotoSwipeLightboxStub as default };